const { setInitialised, useDots, useArrows } = window.BAO.Carousel.plugins

class ShopByShape extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.onSlideClick = this.onSlideClick.bind(this)

    this.els.slide.elements.forEach(el => {
      this.listeners.add(el, 'click', this.onSlideClick)
    })
  }

  onSlideClick (e) {
    if (e.currentTarget.classList.contains('sec-ShopByShape_Slide-primary')) return

    e.preventDefault()

    this.carousel.moveToIdx(parseInt(e.currentTarget.dataset.slide))
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        slides: {
          perView: 1,
          spacing: 20,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 901px)': {
            renderMode: 'custom',
          },
        },
        slideChanged: instance => {
          const activeSlide = instance.track.details.rel

          this.els.slide.elements.forEach(slideEl => {
            const parent = slideEl.parentNode
            const index = Array.prototype.indexOf.call(parent.children, slideEl)

            const totalSlides0 = parent.childElementCount - 1

            const nextSlide = activeSlide === totalSlides0 ? 0 : activeSlide + 1
            const prevSlide = activeSlide === 0 ? totalSlides0 : activeSlide - 1

            const nextNextSlide = nextSlide === totalSlides0 ? 0 : nextSlide + 1
            const prevPrevSlide = prevSlide === 0 ? totalSlides0 : prevSlide - 1

            slideEl.classList.toggle(
              'sec-ShopByShape_Slide-primary',
              index === activeSlide,
            )

            slideEl.classList.toggle(
              'sec-ShopByShape_Slide-next',
              index === nextSlide,
            )

            slideEl.classList.toggle(
              'sec-ShopByShape_Slide-prev',
              index === prevSlide,
            )

            slideEl.classList.toggle(
              'sec-ShopByShape_Slide-nextNext',
              index === nextNextSlide,
            )

            slideEl.classList.toggle(
              'sec-ShopByShape_Slide-prevPrev',
              index === prevPrevSlide,
            )

            if (index === activeSlide) {
              const shape = slideEl?.dataset?.shape
              const url = slideEl?.dataset?.url

              if (this?.els?.button?.exists) {
                this.els.button.element.href = url
              }

              if (this?.els?.shape?.exists) {
                this.els.shape.element.innerHTML = shape
              }
            }
          })
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('shop-by-shape')) {
  customElements.define('shop-by-shape', ShopByShape)
}
